import { createTheme } from "@mui/material/styles";

export const FONT_FAMILY = '"Bahnschrift", Arial, Helvetica, sans-serif';

const theme = createTheme({
  typography: {
    fontFamily: FONT_FAMILY,
  },
});

export default theme;
